


















































import { Component, Prop, Vue } from 'vue-property-decorator';
import moment from 'moment';
import * as $ from 'jquery';

import { ListModel } from '@/models/list-model';
import { ListModelUtil } from '@/model-utils/list-model-util';
import { UserModule } from '@/store/modules/user';

import ListSaveWidget from '@/components/ListSaveWidget.vue';
import UserAvatar from '@/components/UserAvatar.vue';

@Component({ components: { ListSaveWidget, UserAvatar } })
export default class ListCard extends Vue {
  @Prop(ListModel) public list!: ListModel;
  @Prop(Boolean) public isSaved!: boolean;

  get textCss() {
    const key = 'text-color__' + this.list.color;
    const cssMap: any = {};
    cssMap[key] = true;
    return cssMap;
  }

  get saveIcon() {
    if (!this.isSaved) {
      return require('@/assets/images/icon__sharp-bookmark_border-24px.svg');
      // '@/icon__sharp-bookmark_border-24p'
      // '@/assets/images/icon__sharp-bookmark_border-24px--' +
      // this.list.color +
      // '.svg'
    } else {
      return require('@/assets/images/icon__sharp-bookmark-24px.svg');
    }
  }

  get lastUpdated() {
    return moment(this.list.timeLastUpdated).format('MMMM Do YYYY');
	}
	
	fixUrl(imgUrl: string) {
    return imgUrl.split('?')[0];
  }

  get images() {
    if (!this.list.images || this.list.images.length == 0) {
      return [require('@/assets/images/white.png')];
    }
    return this.list.images.slice(0, 2);
  }

  get canEditList() {
    return ListModelUtil.canEditList(this.list, UserModule.currentUserId);
  }

  get isLoggedIn() {
    return UserModule.isLoggedIn;
  }

  get maxImageHeight() {
    if (this.list.tags && this.list.tags.length > 0) {
      return 103;
    } else {
      return 123;
    }
  }
}
